// extracted by mini-css-extract-plugin
export var actualRow = "my-surveys-module--actual-row--a09c7";
export var item = "my-surveys-module--item--cad70";
export var list = "my-surveys-module--list--087a6";
export var separator = "my-surveys-module--separator--5a576";
export var title = "my-surveys-module--title--1f35b";